export function getCookieValue(cookieName: string | null) {
  if (cookieName != null) {
    const cookies = document.cookie ? document.cookie.split('; ') : [];
    const cookie = cookies.find((cookie) => cookie.startsWith(cookieName));
    if (cookie) {
      const value = cookie.split('=').slice(1).join('=');
      return value ? decodeURIComponent(value) : undefined;
    }
  }
}

function getMetaElement(name: string) {
  return document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
}

export function getMetaContent(name: string) {
  const element = getMetaElement(name);
  return element && element.content;
}

export function getCspNonce() {
  const element = getMetaElement('csp-nonce');

  if (element) {
    const { nonce, content } = element;
    return nonce == '' ? content : nonce;
  }
}

export function setMetaContent(name: string, content: string) {
  let element = getMetaElement(name);

  if (!element) {
    element = document.createElement('meta');
    element.setAttribute('name', name);

    document.head.appendChild(element);
  }

  element.setAttribute('content', content);

  return element;
}

export function getCsrfToken() {
  return (
    getCookieValue(getMetaContent('csrf-param')) || getMetaContent('csrf-token')
  );
}
